import { ForgotPasswordTooManyComponent } from '../../components/screens/create-new-password/forgot-password-too-many/forgot-password-too-many.component';
import { TooManyAttemptsSvgComponent } from '../../modules/mapfre-design-library/src/lib/svg/too-many-attempts-svg/too-many-attempts-svg.component';
import { CreatePasswordFormComponent } from '../../components/forms/dynamic-forms/create-password-form/create-password-form.component';
import { MapfreCardComponent } from '../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { MapfreLoadingComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import { AuthenticationService } from '../../_services/_iam/authentication-service.service';
import { CreateNewPasswordFormService } from
  '@services/forms/forgot-password/create-new-password-form/create-new-password-form.service';
import { ClientCredentialsService } from '../../_services/client-credentials/client-credentials.service';
import { UserService } from '../../_services/user.service';
import { UserDetailsService } from '../../_services/profile-settings/user-details.service';
import { ErrorRedirectionService } from '../../_services/error-service/error-redirection.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { ValidateEmailService } from '../../_services/signup-process-service/validate-email.service';
import { ParamHandlingService } from '@services/misc-services/param-handling.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, HeaderComponent, MapfreCardComponent, CreatePasswordFormComponent, TooManyAttemptsSvgComponent, ForgotPasswordTooManyComponent],
  selector: 'app-create-new-password',
  templateUrl: './create-new-password.component.html',
  providers: [CreateNewPasswordFormService],
})
export class CreateNewPasswordComponent implements OnInit {
  createNewPassword: any[];
  expiredLink: boolean;
  paramSubmission: any;
  successChangePassword = false;
  tooManyAttempts = false;
  waitingForResponse = true; // waiting token api response
  user: any = {};
  isCreateUserInfoExists = false;
  whereInTheProcess: string;
  isAcmic = false;

  constructor(
    service: CreateNewPasswordFormService,
    public route: ActivatedRoute,
    public router: Router,
    private acmicService: AcmicService,
    private authenticationService: AuthenticationService,
    private clientCredentialsService: ClientCredentialsService,
    private userDetailsService: UserDetailsService,
    private userData: UserService,
    private errorRedirectionService: ErrorRedirectionService,
    private validateEmailService: ValidateEmailService,
    private paramHandlingService: ParamHandlingService
  ) {
    this.createNewPassword = service.getInputs();
    this.route = route;
  }

  checkForConfirmation(event): void {
    if (event) {
      this.successChangePassword = event;
    }
  }

  isTokenValid(token, email) {
    if (!token || !email) {
      return false;
    }
    this.authenticationService.logout();
    this.waitingForResponse = true;
    return this.authenticationService.tokenVerification(token, email).subscribe(
      () => {
        this.expiredLink = false;
        this.waitingForResponse = false;
        this.getUserData(email);
      },
      (error) => {
        if (
          error.status === 400 ||
          error.status === 401 ||
          error.status === 403 ||
          error.status === 404 ||
          error.status === 408
        ) {
          this.expiredLink = true;
          this.waitingForResponse = false;
          this.router.navigate(['opps', 'link-expire']);
        } else {
          this.errorRedirectionService.redirect(error.status);
        }
      }
    );
  }

  userConfirmation(event): void {
    this.successChangePassword = event;
  }
  setUserData(data) {
    this.user.userDetails = {
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      email: {
        address: data.email.email,
      },
    };
    this.userData.placeUserInfoInStorage(this.user);
  }
  getUserData(email) {
    let token = '';
    this.route.queryParams.subscribe((params) => {
      token = params.token;
    });
    this.userDetailsService.getUserDataByEmail(token, email).subscribe(
      (data) => {
        this.user.userDetails = {
          firstName: data.firstName,
          middleName: data.middleName,
          lastName: data.lastName,
          email: {
            address: data.email.address,
          },
        };
        this.userData.placeUserInfoInStorage(this.user);
        this.isCreateUserInfoExists = true;
      },
      (error) => {
        if (error.status) {
          this.errorRedirectionService.redirect(error.status);
        }
      }
    );
  }

  ngOnInit() {
    if (this.acmicService.isACMIC()) {
      this.isAcmic = true;
    }
    this.whereInTheProcess =  this.router.url;
    this.clientCredentialsService.getToken().subscribe(
      () => {
        this.route.queryParams.subscribe((params) => {
        this.paramHandlingService.addQueryParamToObj('utm_source',params['utm_source']);
        this.paramHandlingService.addQueryParamToObj('utm_medium',params['utm_medium']);
        this.paramHandlingService.addQueryParamToObj('utm_campaign',params['utm_campaign']);
          if (!this.whereInTheProcess.includes('createnewpassword')) {
            if (params) {
              return this.isTokenValid(params.token, params.email);
            }
          } else {
            this.waitingForResponse = false;
            this.expiredLink = false;
            this.successChangePassword = true;
            if (params.email) {
              this.authenticationService
                .verifyForUserExists(params.email)
                .subscribe(
                  (data) => {
                    if(data) {
                      this.router.navigate(['/opps/link-expire']);
                    } else {
                      this.validateEmailService
                      .getUserDataByEmail(params.email)
                      .subscribe(
                        (data) => {
                          this.setUserData(data);
                          this.successChangePassword = false;
                          this.isCreateUserInfoExists = true;
                        },
                        (err) => {
                          this.errorRedirectionService.errorRedirectHandler(
                            err
                          );
                          this.successChangePassword = false;
                          this.isCreateUserInfoExists = true;
                        }
                      );
                    }
                  },
                  (error) => {
                    {
                      this.errorRedirectionService.errorRedirectHandler(
                        error
                      );
                      this.successChangePassword = false;
                      this.isCreateUserInfoExists = true;
                    }
                  }
                );
            }
          }
        });
      },
      (errorRes) => {
        if (errorRes.status) {
          this.errorRedirectionService.redirect(errorRes.status);
        }
      }
    );
  }
}
